import { useT } from '@/lib/i18n'
import { useEmmaUI } from '@/components/emma/Emma'
import { VoiceRingArc } from './VoiceRingArc'
import { useVoiceRing, openVoiceSheet } from './useVoiceRing'

/**
 * "Complete your voice profile, n of 18 left" (Brian's profile.html, Nov 3):
 * the same count as the ring on Emma, a bar, and Answer one. Full, it says so.
 */
export function VoiceProfileCard() {
  const t = useT()
  const { ready, progress: p } = useVoiceRing()
  if (!ready || !p.total) return null
  return (
    <section className={`sh-card vr-pcard${p.full ? ' is-full' : ''}`}>
      <div className="vr-pcard__top">
        <b>{p.full ? t('voice.cardFull') : t('voice.cardTitle')}</b>
        <span>{p.full ? t('voice.ofTotal', { total: p.total }) : t('voice.left', { left: p.left, total: p.total })}</span>
      </div>
      <div className="vr-bar vr-bar--lg" role="progressbar" aria-label={t('voice.sheetTitle')} aria-valuemin={0} aria-valuemax={p.total} aria-valuenow={p.n}>
        <i style={{ width: `${Math.round(p.pct * 100)}%` }} />
      </div>
      <div className="vr-pcard__line">{p.full ? t('voice.cardFullLine') : t('voice.cardLine')}</div>
      {!p.full && <button type="button" className="gg-btn sh-btn" onClick={openVoiceSheet}>{t('voice.answerOne')}</button>}
    </section>
  )
}

/** The card in Emma's window while the ring isn't full (voice-ring.js card()). */
export function EmmaVoiceCard() {
  const t = useT()
  const setEmma = useEmmaUI((s) => s.setOpen)
  const { ready, progress: p } = useVoiceRing()
  if (!ready || !p.total || p.full) return null
  return (
    <button type="button" className="vr-ecard" onClick={() => { setEmma(false); openVoiceSheet() }}>
      <VoiceRingArc pct={p.pct} />
      <span className="vr-ecard__t">
        <b>{t('voice.cardTitle')}</b>
        <small>{t('voice.ecardLine', { left: p.left, total: p.total })}</small>
      </span>
      <span className="vr-ecard__go">{t('voice.answerOne')}</span>
    </button>
  )
}
